module.exports = __webpack_public_path__ + "img/v1-5.57a9cf05.png";